import { CardDefinition, LayoutListDefinition, LAYOUT_LIST } from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { TextHelper } from '~/training/sequence/templates/translators/itemHelpers/TextHelper';

export const Cards4: Translator = sequence => {
  // TODO: this should use the carousel item, not the cards...
  const cardsList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.cardlist`,
    values: {
      orientation: 'row',
      align: 'center',
      wrap: true,
      padded: true,
      type: 'ul'
    },
    items: []
  } as LayoutListDefinition;

  const mainList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.list`,
    values: {
      orientation: 'column',
      align: 'center',
      padded: true
    },
    items: []
  } as LayoutListDefinition;

  const root = translate(sequence, item => {
    if (item.__typename === 'Card') {
      cardsList.items.push(
        CardHelper(item as ItemOfType<'Card'>, {
          width: { _: '241px', lg: '268px' },
          height: { _: '338px', lg: '376px' },
          padding: '0px',
          canScroll: true,
          type: 'li'
        })
      );
    } else if (item.__typename === 'Text') {
      mainList.items.push({
        type: LAYOUT_LIST,
        id: `${sequence.id}.list`,
        values: {
          align: 'top',
          padding: '50px 0px 0px 0px'
        },
        items: TextHelper(item as ItemOfType<'Text'>)
      } as LayoutListDefinition);
    }

    return null;
  });

  mainList.items.push(cardsList);
  if (mainList.items.length > 1) {
    // adding a dummy item for spacing... bit hackish but ok
    mainList.items.push({
      type: LAYOUT_LIST,
      id: `${sequence.id}.blank`
    } as LayoutListDefinition);
  }
  root.items.push(mainList);

  return root;
};
